import styled from '@emotion/styled';
import { PCCEProgress } from '../comm/about-qualification/Progress';
import { PCCEQualification } from '../comm/about-qualification/Qualification';
import TestSteps from '@/components/comm/test-steps';

const Container = styled.div`
  display: grid;
  row-gap: 70px;
`;

const AboutQualification = () => (
  <Container>
    <PCCEQualification />
    <PCCEProgress />
    <TestSteps />
  </Container>
);

export default AboutQualification;
